import React, { useEffect } from 'react';
import { getProp } from '../common/utils';
import { OTP_CODE, SEND_OTP } from '../common/views';
export default ({ authEventHandler, authProviderContext = {}, email, setChallengeId, setIsAutoOtp, setView, updateAfterLookup, }) => {
    useEffect(() => {
        // This is an "implicit" public credential, it means the public credential was already "looked up"
        // Hence return that response to the update method so that Headless can update it s state correctly
        updateAfterLookup({
            response: authProviderContext.lookupResponse,
            email,
        });
        const challenges = getProp(authProviderContext, 'lookupResponse.data.otp.getOtpChallenge.challenges', {});
        if (!challenges) {
            authEventHandler({
                event: 'userNotFound',
                data: {
                    email: authProviderContext.publicCredential,
                },
            });
        }
        if (Array.isArray(challenges) && challenges.length > 0) {
            const challengeWithAutoOtp = challenges.find((challenge) => challenge.notified);
            setIsAutoOtp(!!challengeWithAutoOtp);
            setChallengeId(challengeWithAutoOtp ? challengeWithAutoOtp.challengeId : challenges[0].challengeId);
            setView(challengeWithAutoOtp ? OTP_CODE : SEND_OTP);
        }
        else {
            authEventHandler({
                event: 'userIsIneligible',
            });
        }
    }, []);
    return null;
};
